import { PageContent, PageSection } from '@root/Design/Layout';
import { endpoint } from '@root/Services/Router/EndpointRegistry';

export function TagHygiene() {
    return (
        <PageContent>
            <PageSection>Welcome to Tag Manager - Tag Hygiene Page</PageSection>
        </PageContent>
    );
}
endpoint('tag-hygiene', TagHygiene, 'TagHygiene');
